// Projets.js

import React from "react";
import ProjectCard from "./ProjectCard";

function Projets() {
    return (
        <section className="section">
            <div>
                <ProjectCard />
            </div>
        </section>
    );
}

export default Projets;
